var modules_127cd76a = {"panel":"_17gn7n4","header":"_xu36nb","collapse-icon":"_vnz0cm","active":"_ssxc9i","size-16":"_1dxv6qw","padding":"_1ijydw4","size-24":"_j2f3we","size-32":"_1cg01m2","title":"_1dqae3d","subtitle":"_bsexmc","icon":"_1yelvx2","content":"_jiku44","content-wrapper":"_q63h6i","separator-divider":"_19idya","background-light":"_xpvz9t"};
import "../../../assets/BFNCTznx.css";

export { modules_127cd76a as default };
//# sourceMappingURL=Accordion.module.less.js.map
